import { render, staticRenderFns } from "./ViewerAlert.vue?vue&type=template&id=6656e52e"
import script from "./ViewerAlert.vue?vue&type=script&lang=ts"
export * from "./ViewerAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports